module.exports = __webpack_public_path__ + "static/media/1POLICY46.c755f447.jpg";